import * as actions from './Actions';

const parseUserCompany = (payload) => {
    if (!payload) return null;

    return {
        id: payload.id || null,
        username: payload.username || '',
        email: payload.email || '',
        firstName: payload?.profile?.firstName || payload?.firstName || '',
        lastName: payload?.profile?.lastName || payload?.lastName || '',
        roleId: payload.roleId || payload.Role?.roleId,
        roleName: payload.Role?.name,
        posteName: payload.Poste?.name || payload.poste?.name || '',
        role: payload.role || null,
        permissions: payload.permissions || [],
        isActivated: payload.isActivated ?? true,
        isArchived: payload.isArchived ?? false,
        createdAt: payload.createdAt || null,
        updatedAt: payload.updatedAt || null,
        companyData: payload.companyData || null,
        // Prefer canonical Poste from backend, fallback to lowercase poste
        poste: payload.Poste || payload.poste || null,
        posteId: payload.posteId || payload.Poste?.posteId || payload.poste?.posteId || null,
        posteSkillRequirements: Array.isArray(payload.Poste?.skillRequirements) ? payload.Poste.skillRequirements : [],
        // Include evaluations so profile dialog can show assigned skills from list rows
        evaluations: Array.isArray(payload.evaluations) ? payload.evaluations : [],
        profile: {
            ...payload.profile,
            profilePic: payload.profile?.profilePic || null
        }
    };
};

export const userCompanyReducer = (state = [], action) => {
    switch (action.type) {
        case actions.INITIALIZE_USER_COMPANIES:
            return action.payload.map(user => parseUserCompany(user));

        case actions.ADD_USER_COMPANY:
            return [...state, parseUserCompany(action.payload)];

        case actions.UPDATE_USER_COMPANY:
            return state.map(user =>
                user.id === action.payload.id
                    ? parseUserCompany(action.payload)
                    : user
            );

        case actions.DELETE_USER_COMPANY:
            return state.filter(user => user.id !== action.userId);

        case actions.RESTORE_USER_COMPANY:
            return state.filter(user => user.id !== action.userId);

        case actions.ASSIGN_PERMISSIONS_TO_USER_COMPANY:
            return state.map(user =>
                user.id === action.payload.userId
                    ? { ...user, permissions: action.payload.permissions }
                    : user
            );

        case actions.CLEAR_USER_COMPANIES_LIST:
            return [];

        case actions.ASSIGN_POSTE_TO_USER_COMPANY:
            return state.map(user =>
                user.id === action.payload.userId
                    ? {
                        ...user,
                        poste: action.payload.poste,

                        posteId: action.payload.poste?.posteId,
                        posteName: action.payload.poste?.name

                    }
                    : user
            );

        default:
            return state;
    }
};
